const component = require('../component/component');

const varsList = Object.assign({}, component, {
    // one popover instance per help icon; deep-cloned to a fresh array per
    // component instance by hiveMind.newComponent
    popovers: [],

    init: function () {
        component.init.call(this);
        this.initCopyChips();
        this.initHelpPopovers();
    },

    initCopyChips: function () {
        // clicking a variable chip copies its full token to the clipboard
        let chips = this.element.querySelectorAll('[data-zit-var-copy]');
        chips.forEach((chip) => {
            chip.addEventListener('click', () => {
                this.copyVar(chip.dataset.zitVarValue);
            });
        });
    },

    initHelpPopovers: function () {
        // variables with explanatory text carry a help icon; reveal that text in
        // an informational hover popover (plain text, no interactive controls, so
        // a native hover trigger is enough — no manual hover-bridge needed)
        let helps = this.element.querySelectorAll('[data-zit-var-help]');
        helps.forEach((help) => {
            let popover = this.hm.behaviors.popover.create(help, {
                content: help.dataset.zitVarExp,
                trigger: 'hover',
                placement: 'top'
            });
            this.popovers.push(popover);
        });
    },

    copyVar: function (varValue) {
        // copy the full token to the clipboard; the helper confirms it via an info toast
        this.hm.helper.copyToClipboard(varValue);
    }
});

module.exports = varsList;
